export function getPageCount(count, pageSize) {
  if (count === -1) {
    return -1;
  }
  return Math.ceil(count / pageSize || 1);
}
